<script>
import StyledButton from './StyledButton'

export default {
  name: 'StyledLinkButton',

  components: {
    StyledButton
  },

  props: {
    sound: {},
    pad: {},
    color: {},
    gamepad: {},
    shortcut: {},
    href: {},
    to: {},
    mailto: {},
    tel: {},
    external: {},
    noIndex: {},
    submit: {},
    tab: {},
    iconLeft: {},
    iconRight: {},
    loading: {},
    disabled: {}
  },

  methods: {

    onClick () {
      this.$refs.button.onClick()
      // this.$el.click()
      // this.$emit('click')
    },

    onKeyboardClick () {
      this.$el.click()
    }

  }

}
</script>

<template>
  <styled-button
    ref="button"
    v-bind="$props"
    @click.native="onClick"
    @shortkey.native="onKeyboardClick"
  ><slot /></styled-button>
</template>
